import { useState, useEffect } from 'react';

const useProductDataLayer = ({ activeSku, product }) => {
  const [lookedAtSkus, setLookedAtSkus] = useState([]);

  useEffect(() => {
    (async () => {
      const activeVariant = product?.variants?.find(v => v.sku === activeSku);
      if (activeSku && activeVariant && !lookedAtSkus.includes(activeSku)) {
        setLookedAtSkus([...lookedAtSkus, activeSku]);
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'gatsby-product-detail-view',
          ecommerce: {
            detail: {
              products: [
                {
                  name: product?.title,
                  id: activeSku,
                  price: activeVariant.price,
                  brand: product?.vendor,
                  category: product?.productType,
                },
              ],
            },
          },
        });
      }
    })();
  }, [
    activeSku,
    lookedAtSkus,
    product?.productType,
    product?.title,
    product?.variants,
    product?.vendor,
  ]);
};

export default useProductDataLayer;
